export { EndpointsStrategy } from './Endpoints'
export { DetailedEndpointStrategy } from './DetailedEndpoint'
